<template>
  <div class="details-page-wrapper">
    <anchor-navigation v-if="showAnchorTags"/>
    <div v-if="isMobileView">
      <mobile-details />
    </div>
    <div v-else>
      <desktop-details />
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useBreakpoints } from "@/helpers"
import useDetailPage from "./useDetailPage"

const { 
  showComments,
  showRelated,
  showSuggestions,
  showWhereUsed,
  showAttachments,
  showPartCollections
} = useDetailPage()

import AnchorNavigation from "@/components/library/content/details/AnchorNavigation.vue"
import DesktopDetails from "@/components/library/content/details/DesktopDetails.vue"
import MobileDetails from "@/components/library/content/details/MobileDetails.vue"

const { width } = useBreakpoints()
const isMobileView = computed(() => width.value <= 768)
const showAnchorTags = computed(() => showComments.value 
  || showRelated.value 
  || showSuggestions.value 
  || showWhereUsed.value 
  || showAttachments.value
  || showPartCollections.value
)
</script>
